import { authHeader } from "../../../../helpers/auth-header";
import { client } from "../../../../actions";
import axios from "axios";

const uri = "/Voting";
const CancelToken = axios.CancelToken;

let getVotingFileCancel;
export const getVotingFile = async (votingId, fileName) => {
	if (getVotingFileCancel) {
		getVotingFileCancel();
	}
	const response = await client.get(`${uri}/attachment`, {
		headers: authHeader(),
		params: { votingId, fileName },
		cancelToken: new CancelToken(function executor(c) {
			getVotingFileCancel = c;
		}),
	});

	const content = Buffer.from(response.data, "base64");
	const blob = new Blob([content]);
	const downloadUrl = window.URL.createObjectURL(blob);
	return downloadUrl;
};

let getQuestionFileCancel;
export const getQuestionFile = async (questionId, fileName) => {
	if (getQuestionFileCancel) {
		getQuestionFileCancel();
	}
	const response = await client.get(`${uri}/question_attachment`, {
		headers: authHeader(),
		params: { questionId, fileName },
		cancelToken: new CancelToken(function executor(c) {
			getQuestionFileCancel = c;
		}),
	});
	const content = Buffer.from(response.data, "base64");
	const blob = new Blob([content]);
	const downloadUrl = window.URL.createObjectURL(blob);
	return downloadUrl;
};

let getAnswerFileCancel;
export const getAnswerFile = async (itemId, fileName) => {
	if (getAnswerFileCancel) {
		getAnswerFileCancel();
	}

	const response = await client.get(`${uri}/item_attachment`, {
		headers: authHeader(),
		params: { itemId, fileName },
		cancelToken: new CancelToken(function executor(c) {
			getAnswerFileCancel = c;
		}),
	});

	const content = Buffer.from(response.data, "base64");
	const blob = new Blob([content]);
	const downloadUrl = window.URL.createObjectURL(blob);
	return downloadUrl;
};

export const getVotingFilePreview = async (votingId, fileName) => {
	const response = await client.get(`${uri}/preview`, {
		headers: authHeader(),
		params: { votingId, fileName },
	});
	return response.data;
};
export const getQuestionFilePreview = async (questionId, fileName) => {
	const response = await client.get(`${uri}/question_preview`, {
		headers: authHeader(),
		params: { questionId, fileName },
	});
	return response.data;
};
export const getAnswerFilePreview = async (itemId, fileName) => {
	const response = await client.get(`${uri}/item_preview`, {
		headers: authHeader(),
		params: { itemId, fileName },
	});
	return response.data;
};
